import { AllEvaluationMethodsResponse } from '../response';

export class TransactionNotAppliedMethodEvaluationModalPayload {
  transactionId: number;
  transactionIdentifier: string;
  analysisName: string;
  srcJurisdictionIsoCode: string;
  destJurisdictionIsoCode: string;
  srcMethodNameExists: boolean;
  destMethodNameExists: boolean;
  methodEvaluation?: AllEvaluationMethodsResponse;
}
